import { useState } from 'react'
import getInTouchBackground from 'assets/images/become-a-member-background.jpg'
import { useQuery } from 'urql'
import { isServer } from 'data/helpers/ssr'
import { graphql } from 'gql'
import { DestinationRegion } from 'gql/graphql'
import BannerCardSection from './BannerCardSection'
import CustomerGetInTouchModal from 'components/modals/getHelp/CustomerGetInTouchModal'

interface GetInTouchSectionProps {
  className?: string
  region?: DestinationRegion
}

const GetInTouchSection = ({
  className = '',
  region,
}: GetInTouchSectionProps) => {

  const [{ data, fetching }] = useQuery({
    query: graphql(`
      query GetInTouch {
        cmsGetInTouchSection {
          heading
          content
          background_image
        }
      }
    `),
    pause: isServer,
  })

  const [modalOpen, setModalOpen] = useState(false)

  if (isServer || fetching) {
    return null
  }

  return (
    <>
      <BannerCardSection
        className={{
          container: className,
        }}
        includePadding={false}
        bannerImage={getInTouchBackground}
        altText="Get in touch with us"
        subtitle="Get in touch with us"
        heading={data?.cmsGetInTouchSection.heading}
        content={data?.cmsGetInTouchSection.content}
        buttonText="Need help?"
        buttonAction={() => setModalOpen(true)}
        smShowContent
      />

      <CustomerGetInTouchModal
        isOpen={modalOpen}
        onClose={() => setModalOpen(false)}
        onOpen={() => setModalOpen(true)}
        region={region}
      />
    </>
  )
}

export default GetInTouchSection
